export const host = process.env.REACT_APP_API_URL || "http://localhost:5000";
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setavatar`; 
export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`; 
export const getAllMessagesRoute = `${host}/api/messages/getmsg`;
export const clearChatRoute = `${host}/api/messages/clear`;
export const updateProfileRoute = `${host}/api/auth/updateprofile`;
